"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.27,8.75h-2.1V6.16a6.16,6.16,0,0,0-12.33,0V8.75H3.73a.81.81,0,0,0-.81.81V23.19a.81.81,0,0,0,.81.81H20.27a.81.81,0,0,0,.81-.81V9.57A.81.81,0,0,0,20.27,8.75Zm-7.45,7.15v2.42a.81.81,0,0,1-1.63,0V15.91a1.28,1.28,0,0,1-.49-1,1.3,1.3,0,0,1,2.6,0A1.28,1.28,0,0,1,12.81,15.91Zm3.72-7.15H7.47V6.16a4.54,4.54,0,0,1,9.07,0Z",
    fill: "#024965"
  }));
};

exports["default"] = _default;